import { Workflow } from 'src/redux/consts'

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { UbemIOError } from './types'

type ErrorState = {
  error: UbemIOError | null
}
const initialState: ErrorState = {
  error: null,
}
export const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError: (
      state,
      {
        payload,
      }: PayloadAction<{
        error: UbemIOError | null | unknown
        workflow: keyof typeof Workflow | 'all' | string
        key: string
      }>,
    ) => {
      state.error = payload.error as UbemIOError | null
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

// Action creators are generated for each case reducer function
export const { setError, clearError } = errorSlice.actions

export default errorSlice.reducer
